/**
 * Apparel Products Grid & Category Filter Tabs
 */
(function () {
  function initApparelGrid(section) {
    if (!section || section.dataset.apparelGridInitialized) return;
    section.dataset.apparelGridInitialized = 'true';

    const tabButtons = section.querySelectorAll('.apparel-tab-btn');
    const cards = section.querySelectorAll('.apparel-card');
    const emptyState = section.querySelector('.apparel-grid-empty');

    if (!tabButtons.length || !cards.length) return;

    function filterCategory(targetCategory, updateHash = true) {
      let visibleCount = 0;

      // Update active tab styling
      tabButtons.forEach(btn => {
        const isTarget = btn.getAttribute('data-category-target') === targetCategory;
        btn.classList.toggle('is-active', isTarget);
        btn.setAttribute('aria-selected', isTarget ? 'true' : 'false');
      });

      // Show / hide matching cards with clean transitions
      cards.forEach(card => {
        const cardCategory = card.getAttribute('data-category');
        const matches = (targetCategory === 'all' || cardCategory === targetCategory);

        if (matches) {
          card.classList.remove('is-hidden');
          card.style.animation = 'apparelFadeIn 0.3s ease forwards';
          visibleCount++;
        } else {
          card.classList.add('is-hidden');
          card.style.animation = 'none';
        }
      });

      // Empty state handler
      if (emptyState) {
        emptyState.style.display = visibleCount === 0 ? 'block' : 'none';
      }

      // Update URL hash without causing page jump
      if (updateHash && targetCategory && targetCategory !== 'all') {
        if (history.replaceState) {
          history.replaceState(null, '', '#' + targetCategory);
        } else {
          location.hash = targetCategory;
        }
      }
    }

    // Attach click listeners to each tab button
    tabButtons.forEach(btn => {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        const target = this.getAttribute('data-category-target');
        if (target) {
          filterCategory(target, true);
        }
      });
    });

    // Check URL hash on initial load
    let initialCategory = '';
    const hash = window.location.hash ? window.location.hash.replace('#', '') : '';
    if (hash) {
      const matchingBtn = Array.from(tabButtons).find(btn => btn.getAttribute('data-category-target') === hash);
      if (matchingBtn) {
        initialCategory = hash;
      }
    }

    // Default to the first active or first tab
    if (!initialCategory) {
      const activeBtn = section.querySelector('.apparel-tab-btn.is-active') || tabButtons[0];
      if (activeBtn) {
        initialCategory = activeBtn.getAttribute('data-category-target');
      }
    }

    if (initialCategory) {
      filterCategory(initialCategory, false);
    }
  }

  // Inject CSS keyframe for smooth filter animation
  const styleEl = document.createElement('style');
  styleEl.textContent = `
    @keyframes apparelFadeIn {
      from { opacity: 0; transform: translateY(6px); }
      to { opacity: 1; transform: translateY(0); }
    }
  `;
  document.head.appendChild(styleEl);

  // Initialize on DOM ready
  function initAll() {
    document.querySelectorAll('.apparel-grid-section').forEach(initApparelGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Support Shopify Theme Editor reloads
  document.addEventListener('shopify:section:load', function (e) {
    const section = e.target.querySelector('.apparel-grid-section');
    if (section) initApparelGrid(section);
  });
})();
